// SW Auto-Apply Discount System
(function() {
  'use strict';
  

  // Check if discount needs to be applied
  function shouldApplyDiscount() {
    const swDiscountCode = sessionStorage.getItem('swDiscount');
    const discountApplied = sessionStorage.getItem('swDiscountApplied');

    // Check if we have a discount code and it hasn't been applied yet
    if (swDiscountCode && !discountApplied) {
      // Check if ANY code is already active
      const activeCode = getActiveDiscountCode();

      if (activeCode) {
        // If the active code matches ours, no need to apply
        if (activeCode.toLowerCase() === swDiscountCode.toLowerCase()) {
          // Mark it as applied
          sessionStorage.setItem('swDiscountApplied', 'true');
          return false;
        } else {
          // URL code has priority - replace the existing code
          return true;
        }
      }

      // No code active, apply ours
      return true;
    }

    return false;
  }

  // Auto-apply discount code
  function autoApplyDiscount() {
    const swDiscountCode = sessionStorage.getItem('swDiscount');
    
    if (!swDiscountCode) return;
    
    
    // Show loading indicator
    showLoadingIndicator();
    
    // Try using Shopify's discount form endpoint first
    const reductionFormData = new FormData();
    reductionFormData.append('form_type', 'storefront_customer_discount');
    reductionFormData.append('utf8', '✓');
    reductionFormData.append('reduction_code', swDiscountCode);
    
    // First try to apply via the discount endpoint
    fetch('/discount/' + encodeURIComponent(swDiscountCode), {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => {
      // Regardless of response, now submit to cart with the code
      const formData = new FormData();
      formData.append('form_type', 'cart');
      formData.append('utf8', '✓');
      
      // Get all current cart items to preserve them
      const cartForm = document.getElementById('cart') || document.querySelector('form[action="/cart"]');
      if (cartForm) {
        // Get all quantity inputs to preserve cart items
        const quantityInputs = cartForm.querySelectorAll('input[name*="updates"]');
        quantityInputs.forEach(input => {
          formData.append(input.name, input.value);
        });
        
        // Get any other cart attributes
        const cartAttributes = cartForm.querySelectorAll('input[name^="attributes"]');
        cartAttributes.forEach(input => {
          formData.append(input.name, input.value);
        });
      }
      
      // Add the discount code - this is the key part
      formData.append('discount', swDiscountCode);
      formData.append('reduction_code', swDiscountCode);
      
      // Submit to cart with discount
      return fetch('/cart', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }).then(response => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Response not OK');
      }
    }).then(html => {
      // Check if discount was actually applied by looking for it in the response
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Check for discount in the returned HTML
      const hasDiscount = tempDiv.querySelector('.cart-discount, .savings .totals__subtotal-value:not(:empty)');
      const hasError = tempDiv.textContent.includes('not valid') || 
                      tempDiv.textContent.includes('expired') || 
                      tempDiv.textContent.includes('Unable to find') ||
                      tempDiv.textContent.includes('discount code isn\'t valid');
      
      // Also check if the discount amount is actually greater than 0
      const discountValueElement = tempDiv.querySelector('.totals__subtotal-value');
      const hasZeroDiscount = discountValueElement && 
                              (discountValueElement.textContent.includes('$0.00') || 
                               discountValueElement.textContent.includes('€0.00') || 
                               discountValueElement.textContent.includes('£0.00'));
      
      if (hasError || hasZeroDiscount) {
        console.error('Discount code is invalid, expired, or provides no discount');
        hideLoadingIndicator();
        showInvalidCodeMessage(swDiscountCode);
        // Clear the invalid code
        sessionStorage.removeItem('swDiscount');
        sessionStorage.removeItem('swDiscountApplied');
        return;
      }
      
      // Check if the discount code badge appears (even if no savings yet)
      const discountBadge = tempDiv.querySelector('.cart__discount-code');
      const hasDiscountRow = tempDiv.querySelector('.totals__subtotal-value .cart__discount-code');
      
      // If we see the discount code in the response, consider it applied
      if (discountBadge || hasDiscountRow) {
      } else {
        // Double-check by looking for actual savings amount
        const savingsBox = tempDiv.querySelector('.totals[style*="background-color: #d4edda"]');
        if (!savingsBox) {
          console.warn('No discount badge or savings detected, but will reload to check');
          // Don't clear the code yet, let the page reload and check
        }
      }
      
      // Mark discount as applied
      sessionStorage.setItem('swDiscountApplied', 'true');
      sessionStorage.setItem('swLastAppliedCode', swDiscountCode);
      
      // Reload page to show updated prices with discount
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }).catch(error => {
      console.error('Error applying discount:', error);
      hideLoadingIndicator();
      // Try alternative method
      alternativeDiscountApply(swDiscountCode);
    });
  }

  // Alternative method to apply discount using direct form submission
  function alternativeDiscountApply(discountCode) {
    
    // Find the cart form
    const cartForm = document.getElementById('cart') || document.querySelector('form[action="/cart"]');
    
    if (!cartForm) {
      console.error('No cart form found for alternative method');
      return;
    }
    
    // Ensure discount input exists
    let discountInput = cartForm.querySelector('input[name="discount"]');
    if (!discountInput) {
      discountInput = document.createElement('input');
      discountInput.type = 'hidden';
      discountInput.name = 'discount';
      cartForm.appendChild(discountInput);
    }
    discountInput.value = discountCode;
    
    // Look for the "Apply discount" button specifically
    const applyDiscountBtn = cartForm.querySelector('button[name="checkout"]:not(#checkout)') || 
                             document.querySelector('.swShowWhenManualDiscount button');
    
    if (applyDiscountBtn) {
      // Click the apply discount button
      applyDiscountBtn.click();
    } else {
      // Create a hidden button to apply discount (not checkout)
      const hiddenApplyBtn = document.createElement('button');
      hiddenApplyBtn.type = 'submit';
      hiddenApplyBtn.name = 'apply_discount';
      hiddenApplyBtn.style.display = 'none';
      hiddenApplyBtn.value = '1';
      cartForm.appendChild(hiddenApplyBtn);
      
      // Click it to submit
      hiddenApplyBtn.click();
    }
  }

  // Show loading indicator
  function showLoadingIndicator() {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.id = 'sw-discount-loading';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    `;
    
    overlay.innerHTML = `
      <div style="text-align: center;">
        <div style="
          width: 50px;
          height: 50px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #4CAF50;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        "></div>
        <h3 style="color: #4CAF50; font-size: 24px; margin-bottom: 10px;">
          🎉 Applying Your Discount!
        </h3>
        <p style="color: #666; font-size: 16px;">
          Please wait while we apply your special discount code...
        </p>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
    
    document.body.appendChild(overlay);
  }

  // Hide loading indicator
  function hideLoadingIndicator() {
    const overlay = document.getElementById('sw-discount-loading');
    if (overlay) {
      overlay.remove();
    }
  }

  // Show invalid code message
  function showInvalidCodeMessage(code) {
    // Remove any existing message
    const existingMessage = document.querySelector('.sw-invalid-code-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    // Create error message
    const errorMessage = document.createElement('div');
    errorMessage.className = 'sw-invalid-code-message';
    errorMessage.style.cssText = `
      background: linear-gradient(135deg, #f44336, #d32f2f);
      color: white;
      padding: 20px;
      border-radius: 8px;
      margin: 20px auto;
      max-width: 600px;
      text-align: center;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 10000;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      animation: shake 0.5s;
    `;
    
    errorMessage.innerHTML = `
      <div style="position: relative;">
        <button onclick="this.parentElement.parentElement.remove()" style="
          position: absolute;
          right: -10px;
          top: -10px;
          background: white;
          color: #f44336;
          border: none;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          cursor: pointer;
          font-size: 20px;
          font-weight: bold;
        ">×</button>
        <h3 style="margin: 0 0 10px 0; font-size: 24px;">
          ⚠️ Invalid Discount Code
        </h3>
        <p style="margin: 0 0 10px 0; font-size: 16px;">
          The discount code <strong>"${code}"</strong> is not valid or has expired.
        </p>
        <p style="margin: 0; font-size: 14px; opacity: 0.9;">
          Please check the code and try again, or contact support if you believe this is an error.
        </p>
      </div>
    `;
    
    // Add shake animation
    if (!document.querySelector('#sw-shake-animation')) {
      const style = document.createElement('style');
      style.id = 'sw-shake-animation';
      style.textContent = `
        @keyframes shake {
          0%, 100% { transform: translate(-50%, -50%) translateX(0); }
          25% { transform: translate(-50%, -50%) translateX(-10px); }
          75% { transform: translate(-50%, -50%) translateX(10px); }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(errorMessage);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (errorMessage.parentNode) {
        errorMessage.remove();
      }
    }, 5000);
  }

  // Helper function to get savings from footer
  function getSavingsFromFooter() {
    const totalSavingsBox = document.querySelector('.totals[style*="background-color: #d4edda"] span[style*="color: #155724"]:last-child');
    if (totalSavingsBox) {
      const savingsText = totalSavingsBox.textContent.trim();
      // Extract just the amount and percentage part
      const match = savingsText.match(/(\$[\d,]+\.?\d*\s+\w+\s+\(\d+%\))/);
      if (match) {
        return match[1];
      }
    }
    return null;
  }

  // Get the actually active discount code from the cart
  function getActiveDiscountCode() {
    // Look for the code in the discount section (where Shopify shows active discounts)
    const codeElements = document.querySelectorAll('.code');
    for (const elem of codeElements) {
      // Check if this element is within the discount/savings section
      const parent = elem.closest('.totals__subtotal-value, .cart-discount, .savings');
      if (parent) {
        const codeText = elem.textContent.trim();
        return codeText;
      }
    }
    
    // Alternative: check in cart level discount applications
    const discountTitle = document.querySelector('.cart-discount__title');
    if (discountTitle) {
      const text = discountTitle.textContent.trim();
      return text;
    }
    
    return null;
  }

  // Check if the specific discount code is actually active in cart
  function isDiscountCodeActive(code) {
    if (!code) return false;
    
    
    const activeCode = getActiveDiscountCode();
    
    if (activeCode) {
      const isMatch = activeCode.toLowerCase() === code.toLowerCase();
      return isMatch;
    }
    
    // Fallback: Check if there's any discount amount > 0 and no other code is active
    const discountValue = document.querySelector('.totals__subtotal-value[style*="green"]');
    if (discountValue && !discountValue.textContent.includes('$0.00')) {
      // Only assume it's ours if no other code is visibly active
      return false; // Don't assume, better to be safe
    }
    
    return false;
  }

  // Empty function kept for backward compatibility
  function addSavingsCelebration() {
    return;
  }

  // Reset discount applied flag when code changes
  function checkDiscountChange() {
    const currentCode = sessionStorage.getItem('swDiscount');
    const lastAppliedCode = sessionStorage.getItem('swLastAppliedCode');
    
    if (currentCode !== lastAppliedCode) {
      sessionStorage.removeItem('swDiscountApplied');
      sessionStorage.setItem('swLastAppliedCode', currentCode || '');
    }
  }

  // Initialize
  function init() {
    
    // Only run on cart page
    if (window.location.pathname !== '/cart' && !document.querySelector('.cart-drawer')) {
      return;
    }
    
    const swDiscountCode = sessionStorage.getItem('swDiscount');
    
    // Check if discount code has changed
    checkDiscountChange();
    
    // Check for active discount codes - try multiple times with shorter delays
    const checkForDiscounts = (retryCount = 0) => {
      const activeCode = getActiveDiscountCode();

      if (swDiscountCode) {
        // We have a URL discount code to apply
        if (activeCode && activeCode.toLowerCase() === swDiscountCode.toLowerCase()) {
          // Our URL code is already active, mark as applied
          sessionStorage.setItem('swDiscountApplied', 'true');
          return true;
        }

        // URL code not active yet (or different code active) - apply it
        // URL code has priority over any manually entered code
        if (shouldApplyDiscount()) {
          autoApplyDiscount();
        }
        return true;
      }

      // No URL code in session - nothing to do
      return true;
    };
    
    // Try immediately first
    if (!checkForDiscounts()) {
      // If not successful, retry with shorter delays
      setTimeout(() => checkForDiscounts(1), 300);
      setTimeout(() => checkForDiscounts(2), 800);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also run when cart drawer opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('[id*="cart-icon"], .header__icon--cart')) {
      setTimeout(init, 300);
    }
  });
})();